import { Component } from '@angular/core';

@Component({
  selector: 'ea-fiscality-rent-ceilings',
  templateUrl: './fiscality-rent-ceilings.component.html',
  styleUrls: ['./fiscality-rent-ceilings.component.scss'],
  standalone: false,
})
export class FiscalityRentCeilingsComponent {}
